import * as Forms   from '../../components/forms';
import { useState } from 'react';
import React        from 'react';


export default function ConnectProfile({ connectProfile, name, placeholder, getProfileID }) {
  const [ profileURL, setProfileURL ] = useState(null);

  function save({ profileURL: url }) {
    const profileID = getProfileID(url);
    if (profileID) {
      connectProfile(profileID);
      setProfileURL(url);
    } else
      throw new Error('Invalid Profile URL');
  }

  return (
    <React.Fragment>
      <div className="list block inset">
        <h3>{name} Profile</h3>
        <p>Connect your {name} page to your Broadly account to collect new reviews. </p>
      </div>
      <div className="profile-connect list block inset">
        <Forms.Form {...{ record: { profileURL }, save }}>
          <Forms.Error/>
          <Forms.Input
            name="profileURL"
            type="url"
            label={`Your ${name} URL`}
            placeholder={placeholder}
            required={true}
            autoComplete="off"
          />
          <Forms.Button label={`Connect ${name} Profile`}/>
        </Forms.Form>
      </div>
    </React.Fragment>
  );
}
